// Font Awesome picker body for the sidebar's icon modal. Emits a class string, '' to remove, or cancels.
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { OmpIconStyle } from '../../../_models';
import {
  loadOmpIconIndex,
  ompIconChar,
  ompIconClass,
  OmpIconMatch,
  parseOmpIconClass,
  searchOmpIcons,
} from '../../../_helpers';

const SEARCH_DELAY_MS = 150;
const RESULT_LIMIT = 300;

@Component({
  selector: 'omp-icon-picker',
  templateUrl: './omp-icon-picker.component.html',
  styleUrls: ['./omp-icon-picker.component.scss'],
})
export class OmpIconPickerComponent implements OnInit, OnDestroy {
  @Input() value = '';
  @Output() pick = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  public tabs = [
    { style: OmpIconStyle.Solid, title: 'Solid' },
    { style: OmpIconStyle.Regular, title: 'Outline' },
    { style: OmpIconStyle.Brands, title: 'Brands' },
  ];
  public activeStyle: string = OmpIconStyle.Solid;
  public pattern = '';
  public results: OmpIconMatch[] = [];
  public total = 0;
  public loading = true;
  public failed = false;

  private index: any = null;
  private timer: any = null;

  ngOnInit() {
    const current = parseOmpIconClass(this.value);
    if (current) {
      this.activeStyle = current.style;
    }
    loadOmpIconIndex().then(
      (index) => {
        this.index = index;
        this.loading = false;
        this.scan();
      },
      () => {
        this.loading = false;
        this.failed = true;
      }
    );
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
  }

  selectTab(style: string) {
    this.activeStyle = style;
    this.scan();
  }

  onPatternChange(pattern: string) {
    this.pattern = pattern;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.scan(), SEARCH_DELAY_MS);
  }

  isSelected(match: OmpIconMatch): boolean {
    return this.value === ompIconClass(match.style, match.name);
  }

  glyph(match: OmpIconMatch): string {
    return ompIconChar(match.unicode);
  }

  choose(match: OmpIconMatch) {
    this.pick.emit(ompIconClass(match.style, match.name));
  }

  remove() {
    this.pick.emit('');
  }

  private scan() {
    if (this.index) {
      const matches = searchOmpIcons(this.index, this.activeStyle, this.pattern);
      this.total = matches.length;
      this.results = matches.slice(0, RESULT_LIMIT);
    }
  }
}
